<template>
  <div class="width-100 flex-column align-items-center justify-content-start min-height" id="body-div">
    <div class="width-100 height-100 flex-column align-items-center justify-content-start padding-90">
      <div class="width-100 white fs-super-big fw-bold margin-t padding-lr">供应商查询</div>
      <div class="width-100 white fs-mid-sml padding-lr margin-ts">自助查询库内供应商信息</div>
      <div class="width-100 bg-white padding-lr padding-Tb-20 margin-t br-reg flex-column align-items-center justify-content-center">
        <div class="width-100 fs-mid fw-mid">
          {{ info.companyName }}
        </div>
        <div class="width-100 flex-row align-items-center justify-content-start margin-tx flex-wrap">
          <div
            style="padding: 2px 10px; background: #ecf1ff; color: #4c7dff"
            class="br-big fs-sml margin-rs margin-bs"
            v-for="(its, index) in info.companyTypeArr"
            :key="index"
          >
            {{ its }}
          </div>
        </div>
        <div class="flex-row align-items-center justify-content-start width-100 margin-ts grey-999">
          <van-image width="16px" height="16px" :src="require('../../assets/image/supplier/tx2.png')" fit="contain" class="margin-rs" />
          {{ info.contactsName }} {{ info.contactsPhone }}
        </div>
        <div class="width-100 flex-row justify-content-start margin-ts fs-sml grey-999">
          <van-image :src="require('../../assets/image/supplier/send.png')" width="16px" height="16px" fit="contain" class="margin-rs" />
          {{ info.companyAddress }}
        </div>
        <div class="margin-tx fs-mid-sml grey-999">
          {{ info.companyBusinessScope }}
        </div>
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-t">
          <div class="width-28 flex-column align-items-center justify-content-around" style="height: 3rem">
            <div class="fs-sml darkgrey">法人</div>
            <div class="fs-mid-sml black">{{ info.legalName }}</div>
          </div>
          <div style="width: 1px; height: 2.5rem; border-right: 1px solid #eee"></div>
          <div class="width-28 flex-column align-items-center justify-content-around" style="height: 3rem">
            <div class="fs-sml darkgrey">注册资金</div>
            <div class="fs-mid-sml black">{{ info.companyRegisteredCapital }}</div>
          </div>
          <div style="width: 1px; height: 2.5rem; border-right: 1px solid #eee"></div>
          <div class="width-40 flex-column align-items-center justify-content-around" style="height: 3rem">
            <div class="fs-sml darkgrey">成立时间</div>
            <div class="fs-mid-sml black">{{ info.companyCreationTime }}</div>
          </div>
        </div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-start margin-t fw-mid fs-mid">
        <div
          style="background: #4c7dff; width: 4px; height: 16px; border-top-right-radius: 5px; border-bottom-right-radius: 5px"
          class="margin-r"
        ></div>
        供应商入库材料
      </div>
      <div class="width-100 flex-column align-items-center justify-content-center margin-t">
        <div class="width-100 bg-white flex-column align-items-center justify-content-center padding-lr" style="border-radius: 4px">
          <div
            class="width-100 flex-row align-items-center justify-content-spaceBetween"
            v-for="(item, index) in fileList"
            :key="index"
            :class="index === fileList.length - 1 ? 'no-bottom-line' : 'has-bottom-line'"
          >
            <div class="fs-mid-sml">{{ item.name }}</div>
            <div class="flex-row align-items-center justify-content-center">
              <van-image
                width="16px"
                height="16px"
                :src="require('../../assets/image/supplier/img.png')"
                fit="contain"
                class="margin-r"
                @click="showFile(item)"
              />
              <van-image width="16px" height="16px" :src="require('../../assets/image/supplier/down.png')" fit="contain" @click="downFile(item)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { detail, fileList } from '@/api/supplierApi';
import { getDictDetail } from '@/api/commonApi';
import * as dd from 'dingtalk-jsapi';

export default {
  data() {
    return {
      info: {},
      companyTypeList: [],
      fileList: []
    };
  },
  created() {
    getDictDetail('racm_supplier_type').then((res) => {
      if (res.code === 200) {
        this.companyTypeList = res.data;
        this.loadData();
      }
    });
  },
  methods: {
    loadData() {
      let that = this;
      detail(this.$route.query.id).then((res) => {
        if (res.code === 200) {
          if (res.data.companyType) {
            let companyTypeArr = [];
            let typeArr = res.data.companyType.split(',');
            typeArr.forEach((t) => {
              for (let i = 0; i < that.companyTypeList.length; i++) {
                if (t === that.companyTypeList[i].dictValue) {
                  companyTypeArr.push(that.companyTypeList[i].dictLabel);
                  break;
                }
              }
            });
            res.data.companyTypeArr = companyTypeArr;
          }
          this.info = res.data;
        }
      });
      fileList({ supplierId: this.$route.query.id }).then((res) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            if (item.content.indexOf('http') < 0) {
              item.content = 'https://sbp.rarb.cn' + item.content;
            }
          });
          this.fileList = res.data;
        }
      });
    },
    showFile(item) {
      let type = item.type.toUpperCase();
      if (type === 'PDF') {
        let url = 'https://sbp.rarb.cn/profile/html/pdfh5/pdf.html?src=' + item.content;
        dd.biz.util.openLink({ url: url });
      } else if (type === 'DOC' || type === 'DOCX') {
        let url = 'https://view.officeapps.live.com/op/view.aspx?src=' + item.content;
        dd.biz.util.openLink({ url: url });
      } else if (type === 'PNG' || type === 'JPG' || type === 'BMP' || type === 'JPEG' || type === 'GIF') {
        dd.biz.util.previewImage({ urls: [item.content] });
      } else {
        dd.device.notification.alert({
          message: '不支持预览的文件，请下载查看'
        });
      }
    },
    downFile(item) {
      dd.biz.util.openLink({ url: item.content });
    }
  }
};
</script>

<style scoped>
@import '../../assets/css/supplier/common.css';
@import '../../assets/css/supplier/demo1.css';
@import '../../assets/css/supplier/demo2.css';
#body-div {
  background: #f7f7f7;
  background-image: url('../../assets/image/supplier/bg1.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.has-bottom-line {
  padding: 20px 0;
  border-bottom: 1px solid #eeeeee;
}
.no-bottom-line {
  padding: 20px 0;
}
</style>
